// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReportsPage_wrapper__2paX4","header":"ReportsPage_header__1awtS","card":"ReportsPage_card__1RoEc","contactBtn":"ReportsPage_contactBtn__2nyiP"};